(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flagship-location"] && !Shopify.designMode) return;
  try {
      
  const openButton = document.querySelector("[data-open-modal]")
  const closeButton = document.querySelector("[data-close-modal]")
  const modal = document.querySelector("[data-modal]")

  openButton.addEventListener("click", (event) => {
    event.preventDefault()
    modal.showModal()
  })

  closeButton.addEventListener("click", () => {
    modal.close()
  })

  } catch(e) { console.error(e); }
})();
})();
